import * as React from "react";
import { SVGProps } from "react";
const SvgCurrencyDollar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.981 24.028V22.3c2.016-.305 3.491-1.584 3.491-3.744 0-1.439-.647-2.68-3.006-3.419l-.485-.144v-2.79a2.388 2.388 0 0 1 1.548.953l1.853-1.529c-.63-.864-1.62-1.639-3.4-1.782V8.512h-1.495v1.35c-2.485.324-3.42 2.016-3.42 3.744 0 1.458.63 2.735 2.916 3.455l.504.162v2.79c-1.17-.126-1.693-.702-2.107-1.422l-1.853 1.584c.485.901 1.638 2.035 3.96 2.178v1.675h1.494Zm-1.494-9.54c-.45-.27-.595-.612-.595-1.063 0-.449.198-.845.595-1.062v2.125Zm1.494 5.363v-2.124c.468.253.666.595.666 1.063 0 .504-.234.864-.666 1.061Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCurrencyDollar;
